// Detect environment more robustly
function detectEnvironment() {
  // First check build-time environment variable
  if (process.env.REACT_APP_ENV) {

    return process.env.REACT_APP_ENV;
  }
  
  // Fallback to runtime detection based on current hostname
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'LOCAL';
  } else if (hostname.includes('staging.belvoircastle.com')) {
    return 'STAGING';
  } else if (hostname.includes('belvoircastle.com')) {
    return 'LIVE';
  }
  
  // Default fallback

  return 'LOCAL';
}

const ENV = detectEnvironment();

const environments = {
  LOCAL: {
    frontendUrl: 'http://localhost:3000',
    // Point to LIVE site for local development (no MAMP needed!)
    wordpressUrl: 'https://www.belvoircastle.com/wp',
    graphqlEndpoint: 'https://www.belvoircastle.com/wp/graphql',
    apiEndpoint: 'https://www.belvoircastle.com/wp/wp-json'
  },
  STAGING: {
    frontendUrl: 'https://staging.belvoircastle.com',
    wordpressUrl: 'https://staging.belvoircastle.com/wp',
    graphqlEndpoint: 'https://staging.belvoircastle.com/wp/graphql',
    apiEndpoint: 'https://staging.belvoircastle.com/wp/wp-json'
  },
  LIVE: {
    frontendUrl: 'https://www.belvoircastle.com',
    wordpressUrl: 'https://www.belvoircastle.com/wp',
    graphqlEndpoint: 'https://www.belvoircastle.com/wp/graphql',
    apiEndpoint: 'https://www.belvoircastle.com/wp/wp-json'
  }
};

const baseConfig = environments[ENV];

if (!baseConfig) {
  throw new Error(`Invalid environment: ${ENV}`);
}

// Local dev: always hit LIVE WordPress for vehicle lookup so the mu-plugin + secret on production are used.
const liveVehicleLookupBase = 'https://www.belvoircastle.com/wp/wp-json';
const isLocalDevHostname =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const config = {
  ...baseConfig,
  vehicleLookupApiBase: isLocalDevHostname ? liveVehicleLookupBase : baseConfig.apiEndpoint,
};

export default config; 